import React from 'react'
import styled from 'particles/themes/styled'
import { default as BaseSnackbar, SnackbarProps as BaseSnackbarProps, snackbarClasses } from '@mui/material/Snackbar'
import { snackbarContentClasses } from '@mui/material/SnackbarContent'

interface ToastProps extends BaseSnackbarProps {
    open: boolean
    message: string
    autoHideDuration?: number | null
}

const Toast: React.FC<ToastProps> = ({ className, open, message, autoHideDuration = 2500, ...props }) => (
    <BaseSnackbar
        {...props}
        open={open}
        classes={{ root: className }}
        message={message}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={autoHideDuration}
    />
)

export default styled(Toast)`
    &.${snackbarClasses.root} {
        top: 132px;
        .${snackbarContentClasses.root} {
            background-color: ${({ theme }) => theme.colors.surface.primaryInverse};
            padding: 8px 24px;
            opacity: 0.8 !important;
            box-shadow: 0px 1px 3px 0px #0000001f;
            min-width: fit-content;
            max-width: 552px;
            @media screen and (max-width: 600px) {
                flex-grow: initial;
            }
        }
        .${snackbarContentClasses.message} {
            padding: 0px;
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
            color: ${({ theme }) => theme.colors.text.primaryInverse};
            text-align: center;
            @media screen and (max-width: 768px) {
                font-size: 14px;
                line-height: 20px;
            }
        }
    }
`
